export const ADD_SERVICE_ACCOUNT = 'Add Service Account';
export const COPY_SERVICE_ACCOUNT_PASSWORD = 'Service Account Password Copied';
export const COPY_SERVICE_ACCOUNT_ID = 'Service Account ID Copied';
export const NAVIGATE_TO_SERVICE_ACCOUNT_DETAILS = 'View Service Account';
export const RESET_SERVICE_ACCOUNT_PASSWORD = 'Reset Service Account Password';
export const DELETE_SERVICE_ACCOUNT = 'Delete Service Account';
